<template>
  <v-container class="mt-0">
    <v-row class="mt-0">
      <v-img :src="require('../assets/header.jpg')" class="my-3" contain
    /></v-row>
    <!-- <v-row>
      <v-col cols="12"> </v-col> -->

    <v-row class="text-center mt-5 pt-5">
      <v-col class="mb-4" cols="12" lg="4">
        <h1 class="display-2 font-weight-bold mb-3">Sparkle Series</h1>

        <p class="subheading font-weight-regular">for Vigyan Jyoti scholars</p>
      </v-col>

      <v-col class="mb-5" cols="12" lg="8">
        <v-tabs v-model="tab">
          <v-tab>FOR STUDENTS</v-tab>
          <!-- <v-tab>Resources</v-tab> -->
          <v-tab>FOR Teachers</v-tab>
          <v-tab>HALL OF FAME</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-card>
              <br />
              <span class="font-weight-medium">
                ASSESSMENT TEST FOR STUDENTS
              </span>
              <br />
              <br />
              <v-btn
                @click="
                  linkOpen(
                    'https://docs.google.com/forms/d/e/1FAIpQLSdpBTqB68zn5YHBShCLdFEHYAkSrzLO70kNX84ebYHWGe_l9A/viewform'
                  )
                "
                color="error"
                depressed
              >
                ASSESSMENT TEST</v-btn
              >
              <br /><br />
            </v-card>
            <panel-comp></panel-comp>
          </v-tab-item>
          <!-- <v-tab-item>
            <resources></resources>
          </v-tab-item> -->
          <v-tab-item>
            <teachers></teachers>
          </v-tab-item>
          <v-tab-item>
            <hallof-fame></hallof-fame>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>

    <v-row class="text-center">
      <v-col cols="12">
        <v-card elevation="3">
          <v-card-text>
            <div class="font-weight-medium">CONTACT US</div>

            <div class="text--primary">
              For sharing pictures or videos of students watching sessions,
              doing activities and for any questions related to the Sparkle
              Series email us at
              <span>
                <a
                  class="text-decoration-none font-weight-medium"
                  href="mailto:sparklejnv@gmail.com"
                  >sparklejnv@gmail.com</a
                ></span
              >
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
    
 

<script>
import Resources from "./Resources.vue";
import PanelComp from "./PanelComp.vue";
import Teachers from "./Attendance.vue";
import HallofFame from "./HallofFame.vue";
export default {
  components: { Resources, PanelComp, Teachers, HallofFame },
  name: "HelloWorld",
  // components: [InfoComp, XComp],

  data: () => ({
    tab: null,

    images: ["ibmlogo", "ccllogo", "nvslogo", "vigyanjyotilogo", "aiflogo"],
  }),
  methods: {
    linkOpen(mylink) {
      window.open(mylink, "_blank");
    },
  },
};
</script>
